import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const mainNavItems = [
  { name: 'Home', path: '/' },
  { name: 'Restnutzungsdauer', path: '/restnutzungsdauer' },
  { name: 'Gutachten', path: '/gutachten' },
  { name: 'Investments', path: '/investments' },
  { name: 'Spezialgutachten', path: '/spezialgutachten' },
];

const rightNavItems = [
  { name: 'Über Uns', path: '/ueber-uns' },
  { name: 'Kontakt', path: '/kontakt' },
];

const advisoryNavItems = [
  { name: 'Pre-IPO-Partner', path: '/pre-ipo-partner' },
  { name: 'Family Office Advisory', path: '/family-office-advisory' },
];

const NavLink = ({ item, active, onClick, className = '' }) => (
  <Link
    to={item.path}
    onClick={onClick}
    className={[
      'whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium leading-none transition-colors duration-200',
      active
        ? 'text-brand-900 bg-brand-50'
        : 'text-brand-700 hover:text-brand-900 hover:bg-brand-50',
      className,
    ].join(' ')}
  >
    {item.name}
  </Link>
);

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-brand-100">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 xl:h-20 lg:h-[5.25rem]">
          {/* Logo */}
          <Link to="/" className="group flex-shrink-0" onClick={closeMenu}>
            <div className="font-bold text-xl lg:text-[1.35rem] tracking-tight text-brand-900 transition-colors group-hover:text-brand-700">
              DR. GRASSL <span className="text-brand-600">&</span> Coll.
            </div>
          </Link>

          {/* Desktop — single row (xl+) */}
          <div className="hidden xl:flex items-center flex-1 min-w-0 ml-8">
            <div className="flex items-center gap-0.5">
              {mainNavItems.map((item) => (
                <NavLink key={item.path} item={item} active={isActive(item.path)} />
              ))}
              {advisoryNavItems.map((item) => (
                <NavLink
                  key={item.path}
                  item={item}
                  active={isActive(item.path)}
                  className="text-brand-600 hover:text-brand-900"
                />
              ))}
            </div>
            <div className="ml-auto flex items-center gap-0.5">
              {rightNavItems.map((item) => (
                <NavLink key={item.path} item={item} active={isActive(item.path)} />
              ))}
            </div>
          </div>

          {/* Desktop — two rows (lg to xl) */}
          <div className="hidden lg:flex xl:hidden flex-col justify-center gap-2 flex-1 min-w-0 ml-6">
            <div className="flex items-center w-full">
              <div className="flex items-center gap-0.5 flex-wrap">
                {mainNavItems.map((item) => (
                  <NavLink key={item.path} item={item} active={isActive(item.path)} />
                ))}
              </div>
              <div className="ml-auto flex items-center gap-0.5">
                {rightNavItems.map((item) => (
                  <NavLink key={item.path} item={item} active={isActive(item.path)} />
                ))}
              </div>
            </div>
            <div className="flex items-center justify-end gap-1 border-t border-brand-100 pt-2">
              <span className="px-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-400 select-none">
                Advisory
              </span>
              {advisoryNavItems.map((item) => (
                <NavLink
                  key={item.path}
                  item={item}
                  active={isActive(item.path)}
                  className="text-brand-600 hover:text-brand-900"
                />
              ))}
            </div>
          </div>

          {/* Mobile / Tablet menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg text-brand-700 hover:text-brand-900 hover:bg-brand-50 transition-colors"
            aria-label={isOpen ? 'Menü schließen' : 'Menü öffnen'}
            aria-expanded={isOpen}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile / Tablet Navigation */}
        {isOpen && (
          <div className="lg:hidden border-t border-brand-100 py-3 max-h-[calc(100vh-5rem)] overflow-y-auto">
            <div className="flex flex-col gap-0.5">
              {mainNavItems.map((item) => (
                <NavLink
                  key={item.path}
                  item={item}
                  active={isActive(item.path)}
                  onClick={closeMenu}
                  className="px-4 py-3 text-[15px]"
                />
              ))}

              <div className="mt-2 border-t border-brand-100 pt-3">
                <p className="px-4 pb-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-400">
                  Advisory
                </p>
                {advisoryNavItems.map((item) => (
                  <NavLink
                    key={item.path}
                    item={item}
                    active={isActive(item.path)}
                    onClick={closeMenu}
                    className="px-4 py-3 text-[15px] text-brand-600 hover:text-brand-900"
                  />
                ))}
              </div>

              <div className="mt-2 border-t border-brand-100 pt-2">
                {rightNavItems.map((item) => (
                  <NavLink
                    key={item.path}
                    item={item}
                    active={isActive(item.path)}
                    onClick={closeMenu}
                    className="px-4 py-3 text-[15px]"
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
